'use strict';

export default function routes($stateProvider) {
  'ngInject';
  $stateProvider.state('categories', {
    url: '/categories/:id',
    template: '<categories></categories>',
    authenticate: true
  });
}



// WEBPACK FOOTER //
// ./client/app/categories/categories.routes.js